/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:8a31bb1d-a93f-4ecc-8cfb-b8a4da313824",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_dS23ky1cA",
    "aws_user_pools_web_client_id": "6v0lj14iq3ueguupulv3qrtdhm",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "b2cproduct-dev-mimonprod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
